import React, { FC, useState } from 'react';

import {
	BUTTON_TYPES,
	EvButton,
	EvComboboxOption,
	EvIcon,
	EvSelectNew
} from '@evinced-private/ui-common';

import { IScopeRuleUIFormat } from '../../../../interfaces/ScopeRuleUIFormat';
import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';
import RemoveIcon from '../../../icons/RemoveIcon.svg?raw';

const REMOVE_ISSUE_BUTTON_TITLE = 'Remove Issue Type Rule';
const ISSUE_SEVERITIES_ACTIONS: EvComboboxOption[] = [
	{ label: 'Include Severities', value: SCOPE_ACTIONS.INCLUDE },
	{ label: 'Exclude Severities', value: SCOPE_ACTIONS.EXCLUDE }
];

interface IssueSeveritiesRuleRowProps {
	rule: IScopeRuleUIFormat;
	issueSeveritiesList: EvComboboxOption[];
	onRemove: () => void;
	onRuleChange: (rule: IScopeRuleUIFormat) => void;
}

export const IssueSeveritiesRuleRow: FC<IssueSeveritiesRuleRowProps> = ({
	rule,
	issueSeveritiesList,
	onRemove,
	onRuleChange
}) => {
	const [selectedAction, setSelectedAction] = useState<EvComboboxOption>(
		ISSUE_SEVERITIES_ACTIONS.find((action) => action.value === rule.scopeAction)
	);

	const [selectedIssueSeverities, setSelectedIssueSeverities] = useState<EvComboboxOption[]>(() => {
		if (rule.issueSeverities?.length) {
			return rule.issueSeverities.map((severity: string) => ({ label: severity, value: severity }));
		}

		return [];
	});

	return (
		<div className="rule-row">
			<EvSelectNew
				id="issue-severity-rule-select"
				options={ISSUE_SEVERITIES_ACTIONS}
				selectedValue={[selectedAction]}
				onSelectChange={(selected) => {
					setSelectedAction(selected[0]);
					onRuleChange({ ...rule, scopeAction: selected[0].value as SCOPE_ACTIONS });
				}}
				placeholder="Select Action"
				label="Action"
				className="rule-action-control"
			/>
			<EvSelectNew
				id="issue-severity-select-list"
				options={issueSeveritiesList}
				selectedValue={selectedIssueSeverities}
				onSelectChange={(selected) => {
					setSelectedIssueSeverities(selected);
					onRuleChange({ ...rule, issueSeverities: selected.map((issue) => String(issue.value)) });
				}}
				placeholder="Select Severity"
				label="Severity"
				isMultiple
				className="rule-value-control"
			/>
			<EvButton
				className="delete-rule-btn"
				key="Remove"
				title={REMOVE_ISSUE_BUTTON_TITLE}
				type={BUTTON_TYPES.ICON}
				onClick={onRemove}
			>
				<EvIcon icon={RemoveIcon} />
			</EvButton>
		</div>
	);
};
